module.exports = __webpack_public_path__ + "img/Speaker=Don Munasinghe.61f3b77e.png";